module.exports = __webpack_public_path__ + "static/media/infoYellow.09fcaf99.svg";